import { AuthProvider, useAuth } from './context/AuthContext.jsx';
import { ThemeProvider, useTheme } from './context/ThemeContext.jsx';
import LoginScreen from './components/LoginScreen.jsx';
import FontVault from './components/FontVault.jsx';

function AppContent() {
  const { isAuthenticated, loading } = useAuth();
  const { theme } = useTheme();

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh', background: theme.bg,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontFamily: "'Aeonik', Arial, Helvetica, sans-serif",
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            width: 48, height: 48,
            background: theme.accent,
            borderRadius: 0, display: 'inline-flex',
            alignItems: 'center', justifyContent: 'center',
            fontSize: 22, fontWeight: 700, color: theme.accentFg,
            animation: 'pulse 1.5s ease-in-out infinite',
          }}>F</div>
          <div style={{ color: theme.textMuted, fontSize: 12, marginTop: 12 }}>
            Loading...
          </div>
        </div>
      </div>
    );
  }

  return isAuthenticated ? <FontVault /> : <LoginScreen />;
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </ThemeProvider>
  );
}
